var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"access-message"},[_c('i',{staticClass:"icofont-warning"}),_c('h1',[_vm._v("Acesso suspenso")]),_c('p',[_vm._v(" Acesso temporariamente suspenso para o seu município. ")]),_c('router-link',{attrs:{"to":"/login"}},[_vm._v("Voltar para o início")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }